// extracted by mini-css-extract-plugin
export default {"mainContainer":"StudentBlock__mainContainer___VifLV","lineHeight24":"StudentBlock__lineHeight24___ZFyaA","textContainer":"StudentBlock__textContainer___FXQ08"};